import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { AccountService, GridFilter, HttpCommonService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { ReviewService } from "src/app/review/review.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { take } from "rxjs/operators";
import { InvoiceHistory } from "../../order/model/invoicehistory.model";
import { SecurityReviewService } from "./security-review.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "ngx-security-review",
  templateUrl: "./security-review.component.html",
  styleUrls: ["./security-review.component.scss"],
  providers: [ReviewService],
})
export class SecurityReviewComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  formGroup: UntypedFormGroup;
  SecurityReviewInfoColumns: form_control[] = [];
  BranchIds: number[] = [];
  SaleMethodIds: number[] = [];
  UserListIds: number[] = [];
  InvoiceCommandIds: number[] = [];
  InvoiceStatusIds: number[] = [];
  InvoiceChangesIds: number[] = [];
  InvoicePayableChangeIds: number[] = [];
  selected: string = "";
  showGrid: boolean = true;
  InvoiceItems: any;
  CompareList: InvoiceHistory[] = [];
  apiName: string;
  accountstatus = undefined;
  InvoiceHistoryColumnInfo: form_control[] = [];
  onFilter: GridFilter[] = [];
  unSortableFilterable: any[] = [];
  SMSType = undefined;
  PaymentState = undefined;
  hasWebId: boolean = false;

  paymentStates = [
    { Id: 0, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Nothing") },
    { Id: 10, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.SentLink") },
    { Id: 20, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.DeliveredLink") },
    { Id: 30, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.OpenFactorLink") },
    { Id: 40, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Paying") },
    { Id: 50, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Paid") },
    { Id: 60, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.FailPayment") },
  ];

  public isMultiBranch =
    (this.accountService.authService.currentInformation().BranchingAdvancedEnabled ||
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().RestaurantCallCenter) &&
    this.accountService.authService.currentBranch?.AccessToAllBranches;

  constructor(
    private service: ReviewService,
    private fb: UntypedFormBuilder,
    private sts: ShowToastrService,
    private splash: SplashFormService,
    private accountService: AccountService,
    private securityService: SecurityReviewService,
    private httpCommonService: HttpCommonService,
    private translate: TranslateService
  ) {}
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.formGroup = undefined;
    this.SecurityReviewInfoColumns = undefined;
    this.BranchIds = undefined;
    this.SaleMethodIds = undefined;
    this.UserListIds = undefined;
    this.InvoiceCommandIds = undefined;
    this.InvoiceStatusIds = undefined;
    this.InvoiceChangesIds = undefined;
    this.InvoicePayableChangeIds = undefined;
    this.InvoiceItems = undefined;
    this.CompareList = undefined;
    this.InvoiceHistoryColumnInfo = undefined;
    this.onFilter = undefined;
    this.unSortableFilterable = undefined;
  }
  ngOnInit(): void {
    this.unSortableFilterable = [...this.unSortableFilterable,"DiscountType", "ClearedUserName"]
    this.apiName = "InvoiceHistory";
    this.securityService.CompareList = [];
    this.securityService.selectedInvoiceId = null;
    this.onFilter = [];
    this.setDetailColumns();
    this.service.startDate = new Date();
    this.service.endDate = new Date();
    this.service.ReportKey = "SecurityReview";
    this.service.startDate$.next(this.service.startDate);
    this.service.endDate$.next(this.service.endDate);
    this.formGroup = this.fb.group({
      SaleMethodIds: this.SaleMethodIds,
      BranchIds: this.BranchIds,
      UserListIds: this.UserListIds,
      InvoiceCommandIds: this.InvoiceCommandIds,
      InvoiceStatusIds: this.InvoiceStatusIds,
      InvoiceChangesIds: this.InvoiceChangesIds,
      InvoicePayableChangeIds: this.InvoicePayableChangeIds,
      SMSType: this.SMSType,
      accountstatus: this.accountstatus,
      PaymentState: this.PaymentState,
    });
    this.setColumns();
  }
  setColumns() {
    this.httpCommonService
      .get("SecurityReview/GetSecurityReviewInfo")
      .pipe(take(1))
      .subscribe(
        (data) => {
          if (data) {
            this.SecurityReviewInfoColumns = data as form_control[];
            this.SecurityReviewInfoColumns = this.SecurityReviewInfoColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => console.log(error)
      );
  }
  onRowSelected(invoice: any) {
    this.onFilter = [];
    this.hasWebId = invoice?.WebId;
    this.securityService.selectedInvoiceId = invoice.Id;
    this.unSortableFilterable = [];
    this.unSortableFilterable.push("CreatedDateTime");

    this.onFilter.push({
      Filed: "InvoiceId",
      Type: "F",
      Value: this.securityService.selectedInvoiceId,
      Operator: "eq",
      Logic: "and",
      Skip: 0,
      Take: 10,
    });
  }
  setDetailColumns() {
    this.splash.openDialog();
    this.httpCommonService
      .get("InvoiceHistory/GetInvoiceHistoryInfo")
      .pipe(take(1))
      .subscribe(
        (data) => {
          if (data) {
            this.InvoiceHistoryColumnInfo = data as form_control[];
            this.InvoiceHistoryColumnInfo = this.InvoiceHistoryColumnInfo.sort((a, b) => a.order - b.order);
            this.splash.closeLoading();
          }
        },
        (error) => {
          this.splash.closeLoading();
        }
      );
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
  goToCompareList() {
    if (!this.securityService.CompareList || this.securityService.CompareList.length === 0) {
      this.sts.showDialog(
        this.translate.instant("ClientApp.FrontOffice.Review.SecurityReview.ComparisonListEmpty"),
        this.translate.instant("ClientApp.FrontOffice.Review.SecurityReview.ErrorMessage")
      );
    } else this.showGrid = false;
  }
  onDetailRowSelected(invoices: InvoiceHistory[]) {
    this.securityService.CompareList = Object.assign([], invoices);
  }
}
